import React from 'react';
import HiresPage from './HiresPage';

export default function Hires() {
    return (
        <div className='table-page'>
            <div className='container' style={{ width: '90rem' }}>
                <h2>Hires</h2>
                <HiresPage />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Hires/Hires.jsx